import React from 'react';
import { isMobile } from 'react-device-detect';

import instagram from '../../../assets/instagram.png';
import youtube from '../../../assets/youtube.png';
// import Avatar from '@material-ui/core/Avatar';

import './css/BroadcastChatMessage.css';
import './css/BroadcastChatMessage.mobile.css';


// function generateUsernameIntials(username) {
//   const initials = username.split(" ").map(word=> word[0].toUpperCase()).join('');
//   return initials;
// }

const WISH_TIPPING = 'wishTipping';
const WISH_COMPLETED = 'wishCompleted';

const ChatMessage = (props) => {
  const socialIcon = () => {
    const { source } = props;
    switch (source) {
      case 'instagram':
        return <img alt="" className="socialIconChat" src={instagram} />;
      case 'youtube':
        return <img alt="" className="socialIconChat" src={youtube} />;
      default:
        return null;
    }
  };

  const { isSpotlight, attributes, isInGroupShow, message: propsMessage, nickname, username, user } = props;
  const name = nickname || username;
  const isMineMessage = user.user && username === user.user.username;
  let containerClassName = 'message-container';
  if (isMineMessage) {
    containerClassName += ' message-container--my-message';
  }
  const isTippingMessage = attributes && attributes.type === 'tippingEvent';
  const isWishTippingMessage = isTippingMessage && attributes?.subType === WISH_TIPPING;
  const isWishCompletedMessage = attributes?.type === WISH_COMPLETED;
  const wishOwnerNickname = attributes?.wishOwnerNickname;
  const calculateTipAmount = (amount) => (amount % 5 === 0 ? amount : amount - 1);
  const isSimpleTippingMessage = !isWishTippingMessage && !isInGroupShow && !isSpotlight;
  let message = '';
  if (isInGroupShow) {
    message = propsMessage;
  } else if (isSpotlight && isTippingMessage) {
    const { tippedStarNickname, nickname, tipsAmmount } = attributes || {};

    if (tippedStarNickname && nickname && tipsAmmount) {
      message = `${nickname} has tipped ${tippedStarNickname} $${calculateTipAmount(tipsAmmount)}`;
    }
  }

  /*  Right now we have 2 different tipping amounts based on the user [10, 25, 50, 100] 
  another set of amounts for a different user is [11, 26, 51, 101] (1 is a fee for new users) 
  so if the tip is divisible by 5 return the same amount if not decrement the tip value from 
  the number */

  return (
    <div className={containerClassName}>
      {/* <span className="msg-usr-img">
        <Avatar className="chat-avatar">
          {generateUsernameIntials(name)}
        </Avatar>
      </span>
      Hide user initials - after launch user profile picture will be in this place*/}
      {
        isTippingMessage ? (
          <div className="message-content tipping-content">
            {(isInGroupShow || isSpotlight) && (
              <span>{message}</span>
            )}

            {isWishTippingMessage && (
              <span><b>{name}</b> participated in the Tempting Wish with <b>${calculateTipAmount(attributes.tipsAmmount)}</b></span>
            )}
            {isSimpleTippingMessage && (
              <span><b>{name}</b> tipped <b>${calculateTipAmount(attributes.tipsAmmount)}</b></span>
            )}
          </div>
        ) : (
          isWishCompletedMessage && wishOwnerNickname ? (
            <div className="message-content">
              <b>{wishOwnerNickname}</b> has completed their Tempting Wish
            </div>
          ) : (
            <div className="message-content">
              {(!isMineMessage || !isMobile) && (
                <span className="message-owner-username"> {socialIcon()} {name}:&nbsp; </span>
              )}
              <span>{propsMessage}</span>

            </div>
          )
        )
      }
    </div>
  );
};

export default ChatMessage;
